import { useMemo } from 'react'

const useDetectOS = () => {
	const ua = navigator.userAgent || ''

	const isIOS = useMemo(() => /iPad|iPhone|iPod|Macintosh/.test(ua), [ua])
	const isAndroid = useMemo(() => /Android/.test(ua), [ua])

	return { isIOS, isAndroid }
}

export default useDetectOS
